import React from 'react';
import { Lock } from 'lucide-react';

const blocked = (l) => [l.put_away && 'put-away', l.picking && 'picking'].filter(Boolean).join(' & ');

// Amber note shown on transfer screens: bin locks never block a bin-to-bin / location transfer.
export const LockedTransferNote = ({ lock, testId, compact = false }) => {
  if (!lock) return null;
  if (compact) {
    return (
      <span
        data-testid={testId}
        title={`Locked for ${blocked(lock)}${lock.label ? ` (${lock.label})` : ''}`}
        className="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800"
      >
        <Lock className="h-3 w-3" /> Locked, transfer allowed
      </span>
    );
  }
  return (
    <p
      data-testid={testId}
      className="mt-2 inline-flex items-start gap-1.5 rounded-md border border-amber-300 bg-amber-50 px-2 py-1 text-xs font-medium text-amber-800"
    >
      <Lock className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>
        Locked for {blocked(lock)}{lock.label ? ` (${lock.label})` : ''}, transfer allowed
        {lock.reason ? ` · ${lock.reason}` : ''}
      </span>
    </p>
  );
};
